import script from "./OnboardingAssignies.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAssignies.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__